import { createApp } from 'vue'
import SvgIcon from '@/icons'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
// 国际化中文
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import 'element-plus/dist/index.css'
// 整体规范化样式
import '@/assets/styles/border.css'
import '@/assets/styles/reset.css'
//引入 echarts
import echarts from 'echarts'
//注册组件
// Vue.prototype.$echarts = echarts

const app=createApp(App)
SvgIcon(app);

app.use(store)

app.use(router)

app.use(ElementPlus, {
    locale: zhCn,
})

app.use(echarts)
app.mount('#app')
